/** Client-side quick cleanup ONLY (server does final normalization) */
export function stripExtraPhoneChars(raw: string) {
  return raw.replace(/[^0-9]/g, "").trim();
}
